import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditIcon from "@mui/icons-material/Edit";
import { IconButton } from "@mui/material";
import { format } from "date-fns";
import React, { useContext } from "react";

import { AppContext } from "../../../context/app-context";
import { Comment } from "../../../generated/gql/graphql";

import { EditComment } from "./edit-comment";

interface SubCommentsProps {
  comments: Comment[];
  commentId: string | number;
  editCommentId: string | number | undefined;
  handleEditComment: (id: string, commet: string) => void;
  removeComment: (id: string) => void;

  setEditCommentId(id: string | undefined): void;
}

export function SubComments(props: SubCommentsProps): React.ReactElement {
  const {
    comments,
    commentId,
    editCommentId,
    removeComment,
    setEditCommentId,
    handleEditComment,
  } = props;

  const { user } = useContext(AppContext);

  const parentComments = comments.filter((c) => c.parentId == commentId);

  return (
    <div>
      {parentComments.length > 0 &&
        parentComments.map((comment) => (
          <div
            key={comment.id}
            className="p-10 bg-slate-100 ml-20 mb-5 rounded-10"
          >
            <div className="flex align-middle justify-between mb-5">
              {comment.id}
              <div className="text-[11px]">
                {comment.dateCreated &&
                  format(new Date(comment.dateCreated), "dd/MM/yyyy HH:mm")}
                {user?.id === comment.dateUpdated && (
                  <>
                    <IconButton
                      onClick={() => setEditCommentId(comment.id)}
                      className="ml-5"
                      color="error"
                      size="small"
                    >
                      <EditIcon fontSize="inherit" />
                    </IconButton>
                    <IconButton
                      onClick={() => removeComment(comment.id)}
                      className="ml-5"
                      color="error"
                      size="small"
                    >
                      <DeleteOutlineIcon fontSize="inherit" />
                    </IconButton>
                  </>
                )}
              </div>
            </div>
            <div className="text-[14px]">
              {/*{(comment.fname || comment.lname) && (*/}
              {/*    <Typography*/}
              {/*        sx={{display: "inline"}}*/}
              {/*        component="span"*/}
              {/*        variant="body2"*/}
              {/*        color="text.primary"*/}
              {/*    >*/}
              {/*        {comment.fname} {comment.lname} -*/}
              {/*    </Typography>*/}
              {/*)}*/}
              <span className="text-slate-500">{` ${comment.comment}`}</span>
            </div>
            <EditComment
              comment={comment}
              editCommentId={editCommentId}
              handleEditComment={handleEditComment}
            />
          </div>
        ))}
    </div>
  );
}
